import * as React from "react";
import classNames from "classnames";
import Icon from "../icons/icon";

export interface IArrowLinkProps {
    className?: string;
    link: string;
}

const ArrowLink = ({ className, link }: IArrowLinkProps) => {
    const baseClass = "arrow-link";
    const componentClasses = classNames(baseClass, className);

    return (
        <div className={componentClasses}>
            <Icon iconId="icon_16_arrow-right-bold" />
            <span dangerouslySetInnerHTML={{ __html: link }} />
        </div>
    );
};

export default ArrowLink;
